module.exports = __webpack_public_path__ + "static/media/3.GI pipes.3fe4bfd6.jpg";